const googleApiKeyEnv = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY;

if (!googleApiKeyEnv) throw Error('Missing environment variable "NEXT_PUBLIC_GOOGLE_MAPS_API_KEY"');

export const GOOGLE_API_KEY = googleApiKeyEnv;
